import { type FC } from 'react';

import { ExploreRelatedItems, SponsoredLabel } from '../pdpMessages';

import dibsCss from 'dibs-css';
import cn from 'classnames';

export const PdpRespSponsoredRelatedItemsSubtitle: FC = () => {
    return (
        <>
            <p className={cn(dibsCss.sassyFontHeaderMedium, dibsCss.textNoir)}>
                {ExploreRelatedItems}
            </p>
            <p className={cn(dibsCss.sassyFontBodySmall, dibsCss.textSatan)}>{SponsoredLabel}</p>
        </>
    );
};
